module.exports = __webpack_public_path__ + "img/LV2.f4370ecf.webp";